import { handleSnackbarClose } from "@/services/slices/main-slice";
import { Loader2, X } from "lucide-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";

interface SnackbarState {
  isOpen: boolean;
  message?: string;
  severity?: "success" | "warning" | "error" | "info" | "loading";
  autoHideDuration?: number;
}

const FlashMessage = () => {
  const dispatch = useDispatch();
  const snackbarState: SnackbarState = useSelector(
    (state: any) => state.main.snackbar
  );
  const { isOpen, message, severity, autoHideDuration } = snackbarState;

  useEffect(() => {
    if (isOpen && message && severity) {
      const commonOptions = {
        duration: severity === "success" ? 3000 : severity === "info" ? 5000 : undefined,
        dismissible: severity === "success" || severity === "error" || severity === "info",
        action: (severity === "success" || severity === "error" || severity === "info")
          ? {
              label: <X className="h-4 w-4" />,
              onClick: () => dispatch(handleSnackbarClose()),
            }
          : undefined,
        onAutoClose: () => {
          if (severity === "success" || severity === "info") {
            dispatch(handleSnackbarClose());
          }
        },
      };

      switch (severity) {
        case "loading":
          toast.loading(
            <div className="flex items-center space-x-2">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>{message}</span>
            </div>,
            { id: "loading-toast", ...commonOptions }
          );
          break;
        case "success":
          toast.success(
            <div className="flex items-center space-x-2">
              <span>{message}</span>
            </div>,
            commonOptions
          );
          break;
        case "error":
          toast.error(
            <div className="flex items-center space-x-2">
              <span>{message}</span>
            </div>,
            commonOptions
          );
          break;
        case "info":
          toast(
            <div className="flex items-center space-x-2">
              <span>{message}</span>
            </div>,
            commonOptions
          );
          break;
        default:
          toast(message, commonOptions);
      }
    } else if (!isOpen && severity === "loading") {
      toast.dismiss("loading-toast");
    }
  }, [isOpen, message, severity, autoHideDuration, dispatch]);

  return null;
};

export default FlashMessage;